import { useEffect, useState } from 'react';
import { App } from 'antd';
import { useNavigate } from 'react-router-dom';

import {
    useDeleteProductMutation,
    useUpdateProductStatusMutation,
} from '../service/products';
import { ProductStatus } from '../service/products.interface';
import getEnvConfig from '../../../../../utils/config/env';
import { botName, webAppName } from '../../../../../utils/common/botInfo';

export const useManageProducts = () => {
    const navigate = useNavigate();
    const { notification } = App.useApp();

    const [currentTooltip, setCurrentTooltip] =
        useState<string>('Скопировать ссылку');

    const [
        deleteProduct,
        { isLoading: isLoadingDelete, isSuccess: isSuccessDelete },
    ] = useDeleteProductMutation();

    const [updateProductStatus, { isSuccess: isSuccessUpdateStatus }] =
        useUpdateProductStatusMutation();

    useEffect(() => {
        if (isSuccessDelete) {
            notification.success({
                message: 'Товар удален',
            });
        }
    }, [isSuccessDelete]);

    useEffect(() => {
        if (isSuccessUpdateStatus) {
            notification.success({
                message: 'Статус товара изменен',
            });
        }
    }, [isSuccessUpdateStatus]);

    const changeProductStatus = async (id: number, status: number) => {
        if (status === ProductStatus.archived) {
            await updateProductStatus({
                id: id,
                status: ProductStatus.active,
            });
        } else
            updateProductStatus({
                id: id,
                status: ProductStatus.archived,
            });
    };

    const manageProduct = (type: string, productId?: number) => {
        const isEdit = typeof productId === 'number';

        return navigate(
            `${getEnvConfig().PUBLIC_PATH}/shops/shop/${
                isEdit ? `${type}-edit/${productId}` : `${type}-create`
            }`
        );
    };

    const copyDirectLink = (shopId: number, productId: number) => {
        const directLink = `https://t.me/${botName}/${webAppName()}?startapp=${shopId}_p=${productId}`;
        void navigator.clipboard
            .writeText(directLink)
            .then(() => setCurrentTooltip('Ссылка скопирована'));

        setTimeout(() => {
            setCurrentTooltip('Скопировать ссылку');
        }, 2000);
    };

    return {
        changeProductStatus,
        deleteProduct,
        isLoadingDelete,
        manageProduct,
        copyDirectLink,
        currentTooltip,
    };
};
